import cn from 'classnames';

import { FA, FontAwesomeIcon } from '@/shared/components/ui/icon';
import { normalizeButtonVariant } from '../../shared/buttonVariants';
import { formatFileSize, getFileTypeIcon } from '../fileCard.utils';
import type { FileCardLayoutProps } from './fileCardLayout.types';
import s from './FileCardButton.module.scss';

/**
 * Button FileCard layout — renders as a compact inline download button.
 * Uses shared button variant styles (CSS modules) for consistency with CustomButton.
 * Shows FA file type icon (PDF, Word, etc.) instead of generic download icon.
 */
export const FileCardButton = ({ attrs, onDownload }: FileCardLayoutProps) => {
  const hasFile = !!attrs.url;
  const variant = normalizeButtonVariant(attrs.buttonVariant || 'primary');

  return (
    <span
      className={cn(s.button, s[variant], !hasFile && s.disabled, 'file-card-button', `file-card-button--${variant}`)}
      onClick={hasFile ? onDownload : undefined}
      role="button"
      title="Download"
    >
      <FA icon={getFileTypeIcon(attrs.ext) as FontAwesomeIcon} />
      {attrs.title || 'Download'}
      {!!attrs.size && <span className={s.size}>{formatFileSize(attrs.size)}</span>}
    </span>
  );
};
